
/**
 * First we will load all of this project's JavaScript dependencies.
 */

require('./bootstrap');

var BASEDIR = window.location.pathname;
var xhr = new window.XMLHttpRequest();

var Page = function () {

    var initPageEvents = function () {

        $(document).on("click", ".lang-select", function () {
            var parent = $(this).parent();
            var selector = parent.find(".lang-list");

            if (selector.hasClass("active")) {
                selector.removeClass('active');
            } else {
                selector.addClass('active');
            }
        });

        $(document).on("click", ".email-cover", function () {
            var id = $(this).data('id');
            var hash = $(this).data('hash');

            $("#recaptcha-modal").attr("aria-labelledby", id);
            $("#recaptcha-modal .modal-id").val(id);
            $("#recaptcha-modal .hash").val(hash);
        });

        $('.email-form').on('submit', function (e) {
            e.preventDefault();
            let data = $(this).serialize();
            let modalId = $(this).children('input[name="modal_id"]').val();
            axios.post('/ajax/getEmailAddress', data)
                .then(function (response) {
                    if (response.data) {
                        let anchor = $('a[data-id="'+ modalId +'"]');
                        anchor.attr('href', 'mailto:' + response.data[0]);
                        anchor.text(response.data[1]);

                        $.each(anchor.data(), function (key) {
                            let attr = 'data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
                            anchor.removeAttr(attr);
                        });
                    }
                }).catch(function (error) {
                    console.log(error);
                });

            $('#recaptcha-modal').modal('hide');
            grecaptcha.reset();
        });

        $(document).on("click", ".mobile-btn", function () {
            if (!$('body').hasClass('active')) return $('body').addClass('active');
            $('body').removeClass('active');
        });

        jQuery('.header .search-icon').click(function(){
	    	jQuery('.header').addClass("search_mode");
	    	jQuery('.search-bar input').focus();
	    });
	    jQuery('.header .search-x').click(function(){
	    	jQuery('.header').removeClass("search_mode");
	    });

	    if(jQuery('.search-result').length > 0 && jQuery(window).width() > 990) jQuery('.header .search-icon').click();

	    jQuery('.search-bar input[name=q]').keyup(function(){

	    	xhr.abort();
		    xhr =$.ajax({
				  type: "POST",
				  url: BASEDIR+'search_results.php',
				  data: {q:jQuery(this).val()},
				  success: function($data){ jQuery('ul.search-autocomplet').html($data);  },
				  dataType: 'html',
				  async: true
				});

	    	if(jQuery(this).val().length > 0) jQuery('ul.search-autocomplet').addClass('visible');
	    	else 							  jQuery('ul.search-autocomplet').addClass('hidden');
	    })

    }

    return {
        //main function to initiate the module
        init: function () {
            initPageEvents();

        }
    };

}();


$(document).ready(function () {
    Page.init();

});


